import React, { useState, useEffect } from 'react';
import '../../App.css';
import { Link, useHistory, useParams, useLocation } from 'react-router-dom';
import * as Colors from '../colors'
import plumber from '../../assets/plumber.png';
import paint from '../../assets/paint.png';
import aircon from '../../assets/aircon.png';
import mover from '../../assets/mover.png';
import marker from '../../assets/marker.png';
import calendar from '../../assets/calendar.png';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Rating from '@mui/material/Rating';
import Api from '../api/api';
import MyLoader from '../util/loader'
import showToast from '../util/toast'
import { statesList } from '../constants/constants'
import Card from '@mui/material/Card';
import { categories, categories1, caribbeanCities } from '../util/cats'

const SearchJobs = () => {
    const history = useHistory()
    const location = useLocation()
    const [loader, setLoader] = useState(false);

    let job_type = location.state.job_type
    let state = location.state.location

    const { category } = useParams()

    const cats = categories1
    const [states, setStates] = useState(caribbeanCities)

    const [pageResults, setPageResults] = useState([
        { id: 1, title: '10' },
        { id: 2, title: '25' },
        { id: 3, title: '50' },
    ])

    const [jobs, setJobs] = useState([])

    // let selectedCat = cats[0].value
    // for (let i = 0; i < cats.length; i++) {
    //     if(cats[i].value === job_type){
    //         selectedCat = cats[i].value
    //     }
    // }

    const [catSel, setCatSel] = useState(job_type);
    const [stateSel, setStateSel] = useState(state);
    const [citySel, setCitySel] = useState('');
    const [ratingSel, setRatingSel] = useState('');
    const [searchTxt, setSearchTxt] = useState('');
    const [pageResultsSel, setPageResultsSel] = useState(pageResults[0].id);

    useEffect(() => {
        searchJobs(catSel, stateSel)
    }, [])

    const searchJobs = (catSel, stateSel) => {
        console.log('catSel: '+catSel);
        console.log('stateSel: '+stateSel);
        
        setLoader(true)
        Api.searchJobs('', catSel, stateSel,
            (response) => {
                setLoader(false)
                console.log(JSON.stringify(response));
                if (response.status === 'success') {
                    setJobs(response.jobs)
                }
                else {
                    showToast('error', response.msg)
                }
            },
            (error) => {
                console.log(error);
                setLoader(false)
                showToast('error', 'Request failed!')
            });
    };

    const getIcon = (job) => {
        let icon = ''
        if (job.job_type === 'plumber') {
            icon = plumber
        }
        else if (job.job_type === 'painting') {
            icon = paint
        }
        else if (job.job_type === 'aircon') {
            icon = aircon
        }
        else if (job.job_type === 'mover') {
            icon = mover
        }
        return icon
    };

    const getJobStatus = (job) => {
        return job.status
    };

    const getJobType = (job) => {
        let jobType = ''
        if (job.job_type === 'plumber') {
            jobType = 'Plumber'
        }
        else if (job.job_type === 'painting') {
            jobType = 'House Painting'
        }
        else if (job.job_type === 'aircon') {
            jobType = 'Aircon'
        }
        else if (job.job_type === 'mover') {
            jobType = 'Domestic Mover'
        }
        return jobType
    };

    return (
        <div style={{ backgroundColor: Colors.background }}>

            <div style={{ backgroundColor: 'white', marginTop: 0, paddingBottom: 20, paddingTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>
                    <div className='my-title'>
                        Search Jobs
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 0, paddingBottom: 10, paddingTop: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>

                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>

                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <InputLabel style={{ fontSize: 18 }} id="demo-select-small">Service</InputLabel>
                            <Select
                                style={{ fontSize: 18 }}
                                labelId="demo-select-small"
                                id="demo-simple-select"
                                value={catSel}
                                label="Service"
                                onChange={(event) => {
                                    setCatSel(event.target.value)
                                    searchJobs(event.target.value, stateSel)
                                }}>
                                {cats.map((item, index) => {
                                    return (
                                        <MenuItem value={item}>{item}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <InputLabel style={{ fontSize: 18 }} id="demo-select-small">State</InputLabel>
                            <Select
                                style={{ fontSize: 18 }}
                                labelId="demo-select-small"
                                id="demo-simple-select"
                                value={stateSel}
                                label="Location"
                                onChange={(event) => {
                                    setStateSel(event.target.value)
                                    searchJobs(catSel, event.target.value)
                                }}>
                                {states.map((item, index) => {
                                    return (
                                        <MenuItem value={item}>{item}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <InputLabel style={{ fontSize: 18 }} id="demo-select-small">City</InputLabel>
                            <Select
                                style={{ fontSize: 18 }}
                                labelId="demo-select-small"
                                id="demo-simple-select"
                                value={citySel}
                                label="City"
                                onChange={(event) => {
                                    setCitySel(event.target.value)
                                }}>
                                {cities.map((item, index) => {
                                    return (
                                        <MenuItem value={item.id}>{item.title}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl> */}

                        {/* <FormGroup
                            style={{ display: 'flex', backgroundColor: 'white', borderRadius: 5, border: '1px solid lightgray', alignItems: 'center' }}>
                            <img
                                style={{ width: 25, height: 25, marginLeft: 10 }}
                                src={search_icon} />
                            <Input
                                style={{ fontSize: 18, borderRadius: 5, borderWidth: 0, paddingLeft: 5 }}
                                type='text'
                                placeholder='Search Pro By Name'
                                value={searchTxt}
                                onChange={(event) => setSearchTxt(event.target.value)} />
                        </FormGroup> */}

                        <div
                            className='vendor-results'
                            style={{ display: 'flex', flex: 1 }}>
                            <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                                <InputLabel style={{ fontSize: 18 }} id="demo-select-small">Results per page</InputLabel>
                                <Select
                                    style={{ fontSize: 18 }}
                                    labelId="demo-select-small"
                                    id="demo-simple-select"
                                    value={pageResultsSel}
                                    label="Results per page"
                                    onChange={(event) => {
                                        setPageResultsSel(event.target.value)
                                    }}>
                                    {pageResults.map((item, index) => {
                                        return (
                                            <MenuItem value={item.id}>{item.title}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </div>

                    </div>

                </div>
            </div>

            <div style={{ backgroundColor: 'white', marginTop: 0, paddingBottom: 20, paddingTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className='home-panel'
                    style={{ alignSelf: 'center' }}>
                    <div style={{ fontSize: 14, color: 'gray' }}>
                        {jobs.length} Jobs Found
                    </div>

                    {jobs.map((item, index) => {
                        return (

                            <Card
                                key={index.toString()}
                                onClick={() => {
                                    // history.push({
                                    //     pathname: '/project-details',
                                    //     state: { job: item }
                                    // })
                                }}
                                sx={{ marginBottom: 2, backgroundColor: Colors.theme3 }}>

                                <button
                                    className='card-hover'
                                    style={{ border: '0px', width: '100%', padding: 0, display: 'flex', flexDirection: 'column' }}>

                                    <div
                                        className='job-item'
                                        style={{ display: 'flex', flexWrap: 'wrap', flexWrap: 'wrap', width: '100%', height: '100%', marginBottom: -19, alignItems: 'center' }}>

                                        <img
                                            className='vendor-img'
                                            style={{ width: 120, height: 120, borderRadius: 0, marginLeft: 2, marginTop: 2, marginBottom: 2, backgroundColor: 'white' }}
                                            src={getIcon(item)} />

                                        <div
                                            className='margin-left-mobile'
                                            style={{ display: 'flex', minWidth: 300, flexDirection: 'column', flex: 1, marginTop: 0, alignItems: 'flex-start' }}>
                                            <div className='vendor-info'>
                                                <div style={{ fontSize: 18, marginLeft: 0, fontWeight: 'bold' }}>
                                                    Request for {getJobType(item)}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: -10, marginTop: 5 }}>
                                                <img
                                                    style={{ width: 30, height: 30, objectFit: 'contain' }}
                                                    src={marker} />
                                                {item.job_type === 'mover' ?
                                                    <div style={{ fontSize: 16, marginLeft: 0, color: 'gray', textAlign: 'start' }}>
                                                        From: {item.job_details.moving_from}, To: {item.job_details.moving_to}
                                                    </div>
                                                    :
                                                    <div style={{ fontSize: 16, marginLeft: 0, color: 'gray', textAlign: 'start' }}>
                                                        Destination: {item.address}, {item.state}
                                                    </div>
                                                }
                                            </div>
                                            
                                            <div style={{ display: 'flex', flex: 1, alignItems: 'center', marginTop: 5 }}>
                                                <img
                                                    style={{ width: 16, height: 16, objectFit: 'contain' }}
                                                    src={calendar} />
                                                <div style={{ fontSize: 16, marginLeft: 10, color: 'gray' }}>
                                                    Work Date: {item.preferred_date}
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{ display: 'flex', flex: 1, flexDirection: 'column', margin: 15 }}
                                            className='vendor-btns'>
                                            {
                                                <div style={{ color: 'gray', fontSize: 16, fontWeight: 'bold', marginLeft: 5, backgroundColor: 'white', borderRadius: 25, padding: 10, paddingLeft: 20, paddingRight: 20 }}>
                                                    {getJobStatus(item)}
                                                </div>
                                            }
                                        </div>

                                    </div>

                                    <div style={{ marginTop: 20, padding: 15, backgroundColor: 'white', width: '100%' }}>

                                        <div
                                            style={{ display: 'flex', flex: 1, flexDirection: 'column' }}
                                            className='vendor-btns'>
                                            <button
                                                onClick={() => {
                                                    history.push({
                                                        pathname: '/vendor-project-details',
                                                        state: {  // location state
                                                            leftPanel: 'quote',
                                                            job: item,
                                                        },
                                                    });
                                                }}
                                                style={{ border: '1px solid ' + Colors.theme1, backgroundColor: 'transparent', width: 150, height: 35, borderRadius: 5 }}>
                                                <div style={{ color: Colors.theme1, fontSize: 16, marginLeft: 5 }}>
                                                    VIEW DETAILS
                                                </div>
                                            </button>
                                        </div>

                                    </div>

                                </button>

                            </Card>
                        )
                    })}

                </div>

            </div>

        </div>
    );
}

export default SearchJobs; 